export enum DIRECTION {
  UP = 'UP',
  DOWN = 'DOWN',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

export enum CircleAction {
  NONE = 'NONE',
  ADD = 'ADD',
  REMOVE = 'REMOVE',
}
